import { Sidebar, SubMenuElement } from './sidebar.component';

export const SIDEBAR_DECLARATIONS: any[] = [Sidebar, SubMenuElement];
